import { Row, Col, Container } from "react-bootstrap";
import LeftPanel from "../../Components/LeftPanel";
import RightPanel from "../../Components/RightPanel";
import Pagination from "../../Components/Pagination";
import SubmitButton from "../../Components/SubmitButton";
import { Redirect } from "react-router";
import { useRouteMatch } from "react-router-dom";
import getProblemForCurrentURL from "../../hooks/problem";

const Problems = () => {
  const { params } = useRouteMatch();
  const problemFiltered = getProblemForCurrentURL(params);

  if (!problemFiltered) {
    return <Redirect to="/404" />;
  }

  return (
    <Container fluid>
      <Row>
        <Col xs={6}>
          <LeftPanel />
        </Col>
        <Col xs={6}>
          <RightPanel />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Pagination />
        </Col>
        <Col xs={6}>
          <SubmitButton />
        </Col>
      </Row>
    </Container>
  );
};

export default Problems;
